/**
 * @generated SignedSource<<0991835f2222a91d32377519f6ebd418>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerDetailsReviewContainer_viewer" | "PdpSharedSellerTabsVariant_viewer">;
  readonly " $fragmentType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$key = {
  readonly " $data"?: PdpRespDealerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsReviewContainer_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2969e944e07367f566b14961fe8930ea";

export default node;
